import {DICT_KEY, getDictNameByCode, getModel, setModel} from "../../../utils/constants";
import SaleSoService from "./SaleSoService";
import ModelUtils from "../../../utils/ModelUtils";
import StockStatisticService from "../../stock/statistic/StockStatisticService";
import {v4 as uuidv4} from "uuid";

const MODEL_KEY = DICT_KEY.SALE_SO;
const storageModel = getModel(MODEL_KEY);
const cacheAble = false;
const saleSoModel = {
    state: cacheAble && storageModel ? storageModel : {
        //查询参数
        searchParam: {},
        //单据列表
        documentList: [],
        //销售订单统计信息
        documentStatistic: {
            purchaseQuantityTotal: 0,
            amountPayableTotal: 0.00,
            amountPaidTotal: 0.00,
            saleCostTotal: 0.00,
            saleProfitTotal: 0.00,
        },
        //单据列表分页信息
        documentPageInfo: {
            total: 0,
            pageNum: 1,
            pageSize: 100
        },
        //选中单据
        selectedDocument: {},
        //选中单据key数组
        selectedDocumentRowKeys: [],
        //单据打印窗口显示
        printDocumentModelVisible: false,


        //单据配件列表
        documentMaterialList: [],
        //选中配件
        selectedDocumentMaterial: null,
        //选中配件key数组
        selectedDocumentMaterialRowKeys: [],
        detailStatistics: {
            //销售数量
            saleTotalNum: 0,
            //赠品总数量
            freeTotalNum: 0,
            //应收总金额
            receivableTotalAmount: 0,
            //商品金额
            saleTotalAmount: 0,
        },

        //添加物料窗口显示
        addMaterialModelVisible: false,
        materialSearchParam: {},
        //待选配件列表
        materialList: [],
        materialPageInfo: {
            total: 0,
            pageNum: 1,
            pageSize: 5
        },
        //已选配件列表
        selectedMaterialList: [],
        paymentDrawerVisible: false,
        formExpand: false,
        formData: {},

    },
    reducers: {
        toggleExpand(state,) {
            state.formExpand = !state.formExpand;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },

        setFormData(state, payload) {
            state.formData = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setDetailStatistics(state, payload) {
            state.detailStatistics = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSearchParam(state, payload) {
            state.searchParam = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setDocumentList(state, payload) {
            state.documentList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setDocumentStatistic(state, payload) {
            state.documentStatistic = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setDocumentPageInfo(state, payload) {
            state.documentPageInfo = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSelectedDocument(state, payload) {
            state.selectedDocument = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSelectedDocumentRowKeys(state, payload) {
            state.selectedDocumentRowKeys = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setPrintDocumentModelVisible(state, payload) {
            state.printDocumentModelVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },

        setDocumentMaterialList(state, payload) {
            state.documentMaterialList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //添加单据中的配件信息
        addDocumentMaterial(state, payload) {
            state.documentMaterialList.push(...payload);
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //移除单据中的配件信息
        removeDocumentMaterial(state, payload) {
            state.documentMaterialList = state.documentMaterialList.filter(el => !!!payload.find(ele => ele === el.key));
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //设置单据中选中的配件
        setSelectedDocumentMaterial(state, payload) {
            state.selectedDocumentMaterial = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSelectedDocumentMaterialRowKeys(state, payload) {
            state.selectedDocumentMaterialRowKeys = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },

        setAddMaterialModelVisible(state, payload) {
            state.addMaterialModelVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setMaterialSearchParam(state, payload) {
            state.materialSearchParam = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //待选配件列表
        setMaterialList(state, payload) {
            state.materialList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setMaterialPageInfo(state, payload) {
            state.materialPageInfo = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSelectedMaterialList(state, payload) {
            state.selectedMaterialList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //添加已选配件
        addSelectedMaterial(state, payload) {
            // state.materialList = state.materialList.filter(el => el.id !== payload.id);
            state.selectedMaterialList.push(payload);
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //删除已选配件
        removeSelectedMaterial(state, payload) {
            // state.materialList.push(payload);
            state.selectedMaterialList = state.selectedMaterialList.filter(el => el.id !== payload.id);
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //设置支付窗口显示
        setPaymentDrawerVisible(state, payload) {
            state.paymentDrawerVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        transSelectedStockItemListToSoItemList(state,) {
            const {priceType} = state.formData;
            const mappedItems = state.selectedMaterialList.map(el => {
                const row = stockItemMapToSoItem(el, priceType);
                const {isProtect, saleNum, giftsNum, salePrice, discount, discountPrice} = row;
                const nRowData = {
                    ...row,
                    oldSalePrice:salePrice,
                    isProtect: isProtect === "1" || isProtect === true ? "1" : "0",
                    aggregateAmount: (salePrice * (saleNum - giftsNum) * discount / 100 - discountPrice).toFixed(2)
                }
                return nRowData;
            })
            state.documentMaterialList = [...state.documentMaterialList, ...mappedItems]
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        updateStatus(state, status) {
            state.selectedDocument = {...state.selectedDocument, ...status};
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
    },
    effects: () => ({
        //加载单据列表
        async loadDocumentList({showMsg = true, duration = 5, data}) {
            const funName = "加载销售单列表";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleSoService.findPage(data);
                const {list, statistics, ...page} = retData;
                const mappedList = list.map(el => ({
                    ...el,
                    key: el.id,
                    orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_STATUS, el.orderStatus),
                    orderTypeName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_ORDER_TYPE, el.orderType),
                    invoiceTypeName: getDictNameByCode(DICT_KEY.CM_DICT.INVOICE_TYPE, el.invoiceType),
                    paymentStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_PAY_STATUS, el.paymentStatus),
                }));
                this.setDocumentList(mappedList);
                this.setDocumentStatistic(statistics);
                const {pageNum = 1} = page;
                this.setDocumentPageInfo({...page, pageNum: pageNum === 0 ? 1 : pageNum});
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async loadSo({showMsg = true, duration = 5, data}) {
            const funName = "加载销售单详细信息";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleSoService.findByIdOrCode(data);
                const {details, ...so} = retData;
                const mappedList = details.map(el => ({
                    ...el,
                    key: el.id,
                    materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit),
                    oldSalePrice:el.salePrice,
                    deliveryStatusName: getDictNameByCode(DICT_KEY.CM_DICT.WH_OUT_STATUS, el.deliveryStatus)
                }))
                this.setSelectedDocument({
                    ...so,
                    orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_STATUS, so.orderStatus),
                });
                this.setDocumentMaterialList(mappedList);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //导出销售单
        async exportSo({showMsg = false, duration = 5, data}) {
            const funName = "导出销售单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleSoService.export(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)
        },
        //新增订单
        async insert({showMsg = true, duration = 5, data}) {
            const funName = "新增销售单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleSoService.insert(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //修改订单
        async update({showMsg = true, duration = 5, data}) {
            const funName = "修改销售单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleSoService.update(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //作废
        async disable({showMsg = true, duration = 5, data}) {
            const funName = "销售单作废";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleSoService.disable(data);
                if (retData) {
                    // this.updateStatus("017005");
                    const orderStatus = "017005";
                    this.updateStatus({
                        orderStatus,
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_STATUS, orderStatus)
                    });
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //结算
        async settle({showMsg = false, duration = 5, data}, rootState) {
            const funName = "销售单结算";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleSoService.settle(data);
                if (retData) {
                    const {saleSo} = rootState;
                    const {selectedDocument} = saleSo;
                    const {receivableAmount} = selectedDocument;
                    const {payTypeCode, payDesc} = data;

                    const orderStatus = "017002";
                    this.setSelectedDocument({
                        ...selectedDocument,
                        orderStatus,
                        paidAmount: receivableAmount,
                        paymentMethod: payTypeCode,
                        payDesc,
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_STATUS, orderStatus)
                    });
                    // this.updateStatus("017002");
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        //库存确认
        async whConfirm({showMsg = false, duration = 5, data}, rootState) {
            const funName = "库存确认";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleSoService.whConfirm(data);
                if (retData) {
                    const {saleSo} = rootState;
                    const {documentMaterialList} = saleSo;

                    let noIssuedNumTotal = 0;
                    const mappedList = documentMaterialList.map(el => {
                        const issuedNum = parseInt(el.issuedNum) + parseInt(el.thisDelivery);
                        const noIssuedNum = parseInt(el.noIssuedNum) - parseInt(el.thisDelivery);
                        noIssuedNumTotal += noIssuedNum;
                        return {
                            ...el,
                            issuedNum,//已出库数量
                            noIssuedNum,//未出库数量
                            thisDelivery: 0,//本次出库量
                        }
                    });
                    //更新明细
                    this.setDocumentMaterialList(mappedList);
                    //需要判断出库数量是否等于销售数量
                    //部分出库-017003;;;全部出库-017004
                    if (noIssuedNumTotal > 0) {
                        // this.updateStatus("017003");
                        const orderStatus = "017003";
                        this.updateStatus({
                            orderStatus,
                            orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_STATUS, orderStatus)
                        });
                    } else {
                        // this.updateStatus("017004");
                        const orderStatus = "017004";
                        this.updateStatus({
                            orderStatus,
                            orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.SALE_STATUS, orderStatus)
                        });
                    }

                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },

        //下载销售单明细导入模板
        async downloadDetailTpl({showMsg = false, duration = 5, data}) {
            const funName = "下载销售单明细导入模板";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SaleSoService.downloadDetailTpl(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)
        },

        //加载库存数据
        async loadStockData({showMsg = false, duration = 5, data = {pageSize: 5}}) {
            let retData = await StockStatisticService.findPage(data);
            const {list, statistic, ...pageInfo} = retData;
            const materialList = list.map(el => ({
                ...el,
                Num:1,
                // key: el.materialCode + "_" + el.shelfCode + "_" + el.inventoryNum,
                key: el.id,
                materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit),
                materialBrandName: getDictNameByCode(DICT_KEY.CM_DICT.BRAND, el.materialBrand),
            }));
            this.setMaterialList(materialList);
            const {pageNum = 1} = pageInfo;
            this.setMaterialPageInfo({...pageInfo, pageNum: pageNum === 0 ? 1 : pageNum});
            // this.setMaterialPageInfo(pageInfo);

        },
    })
}

const stockItemMapToSoItem = (el, priceType) => {
    // console.log(el, priceType)
    const {
        id,
        materialId,
        materialCode,
        materialName,
        replaceNum,
        materialUnit,
        materialUnitName,
        groupCode,
        category,
        Num,
        salesPrice: salePrice0 = 0,
        subSalesPrice = 0,
        warehouseId = "空",
        warehouseName = "空",
        shelfId = "空",
        shelfCode = "空",
        inventoryNum
    } = el;

    return {
        key: id,
        id,
        saleOrderId: null,
        materialId,
        materialCode,
        materialName,
        replaceNum,
        materialUnit,
        materialUnitName,
        groupCode,
        category: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_SORT, category, true),

        saleNum:Num,
        giftsNum: 0,
        salePrice: priceType === "038001" ? salePrice0 : subSalesPrice,//销售价
        taxAmount: 0.00,//总计

        salePrice0,//销售价
        subSalesPrice,//二级销价
        discount: 100,//折扣
        discountPrice: 0.00,//优惠金额
        aggregateAmount: 0.00,//总计
        isProtect: "0",

        warehouseId,
        warehouseName,
        shelfId,
        shelfCode,
        inventoryNum,
        deliveryStatus: "0",
        detailsDesc: "空",

        issuedNum: 0,
        noIssuedNum: 0,
        thisDelivery: 0,
        deliveryStatusName: '无',

        // "deleteFlag": 0,
        // "createTime": "2020-08-18 09:58:12",
        // "updateTime": "2020-08-18 10:28:42",
        // "createUser": "业务员",
        // "updateUser": "tester",
    }
}
/*const stockItemMapToSoItem = el => {
    return {
        "key": uuidv4(),
        "id": el.id,
        "saleOrderId": null,
        "materialId": el.materialId,
        "materialCode": el.materialCode,
        "materialName": el.materialName,
        "replaceNum": el.replaceNum,
        "materialUnit": el.materialUnit,
        "materialUnitName": el.materialUnitName,
        "groupCode": el.groupCode,

        "saleNum": 0,
        "giftsNum": 0,
        "salePrice": !!el.salesPrice ? el.salesPrice : 0.00,
        "discount": 100,//折扣
        "discountPrice": 0.00,//优惠金额
        "taxAmount": 0.00,//总计
        "isProtect": "0",

        "warehouseId": !!el.warehouseId ? el.warehouseId : '空',
        "warehouseName": !!el.warehouseName ? el.warehouseName : '空',
        "shelfId": !!el.shelfId ? el.shelfId : '空',
        "shelfCode": !!el.shelfCode ? el.shelfCode : '空',

        "inventoryNum": el.inventoryNum,
        "deliveryStatus": "001",

        "detailsDesc": "空",
        "issuedNum": 0,
        "noissuedNum": 0,
        "thisDelivery": 0,
        "deliveryStatusName": '无',
        // "deleteFlag": 0,


        // "createTime": "2020-08-18 09:58:12",
        // "updateTime": "2020-08-18 10:28:42",
        // "createUser": "业务员",
        // "updateUser": "tester",
    }
}*/
export default saleSoModel;